/* Brass & Wood — additive behaviors (2026-08-16). Safe to delete. */

/* Toggle behavior for the selected variant option — no page reloads:
   - default page (no ?variant=): the first color is only pre-highlighted; clicking it
     dispatches a native change event so Horizon runs its own instant morph (which also
     puts ?variant= in the URL and filters the gallery to that color).
   - explicitly selected (?variant= in URL): clicking the selected color again fetches
     the base product page in the background and swaps the product section in place —
     back to the full all-colors gallery, no reload.
   pointerup: fires on the real element before the radio toggles; label->input click
   forwarding doesn't re-dispatch it; touch scrolls end in pointercancel, not pointerup. */
(() => {
  async function bwSwapSection(url) {
    try {
      const cur = document.querySelector('[id^="shopify-section-"][id*="__main"]');
      if (!cur) throw new Error('no main section');
      const res = await fetch(url);
      if (!res.ok) throw new Error('fetch failed');
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const next = doc.getElementById(cur.id);
      if (!next) throw new Error('section missing in response');
      cur.replaceWith(document.importNode(next, true));
      history.replaceState({}, '', url);
    } catch (err) {
      window.location.href = url; // graceful fallback
    }
  }

  document.addEventListener(
    'pointerup',
    (e) => {
      if (e.button !== undefined && e.button !== 0) return;
      if (!(e.target instanceof Element)) return;
      const label = e.target.closest('.variant-option__button-label');
      if (!label) return;
      const input = label.querySelector('input[type="radio"]');
      if (!input || !input.checked) return;
      const picker = label.closest('variant-picker');
      if (!picker) return;
      const explicit = new URLSearchParams(window.location.search).has('variant');
      if (explicit) {
        // unclick: back to the full gallery without a reload
        e.preventDefault();
        e.stopPropagation();
        bwSwapSection(picker.dataset.productUrl || window.location.pathname);
      } else {
        // pre-highlighted default: promote to a real selection via the native flow
        e.preventDefault();
        e.stopPropagation();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    },
    true
  );
})();
